"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CalendarView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .MuiTypography-root {\n    font-size: 14px !important;\n  }\n"])));

exports.CalendarView = CalendarView;

//# sourceMappingURL=Calendar.style.js.map